module.exports = __webpack_public_path__ + "static/media/hand.f0c474a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/giftcard/hand.png
// module id = 1856
// module chunks = 6